// extracted by mini-css-extract-plugin
export default {"card":"Y3-z"};